"use strict";

/**
 * Counts how many swatches fit on one line, leaving room for the "+N" link when not all of them do
 * @param {Object} measures - widths in px
 * @param {number} measures.available - width of the swatch row's content box
 * @param {number} measures.swatchWidth - width of one swatch
 * @param {number} measures.gap - gap between swatches
 * @param {number} measures.moreWidth - width of the "+N" link at its widest
 * @param {number} measures.moreGap - gap between the swatches and the "+N" link
 * @param {number} total - number of swatches
 * @param {number} [maximum] - most swatches to show even when more fit
 * @returns {number} how many swatches to show, at least 1
 */
function countFittingSwatches(measures, total, maximum) {
    const cap = maximum > 0 ? Math.min(maximum, total) : total;
    const pitch = measures.swatchWidth + measures.gap;
    if (pitch <= 0 || (total * pitch) - measures.gap <= measures.available) {
        return cap;
    }

    // A capped line still has room for "+N", since the swatches it leaves out made the whole line fit
    const fitting = Math.floor((measures.available - measures.moreWidth - measures.moreGap + measures.gap) / pitch);
    return Math.min(cap, Math.max(1, fitting));
}

module.exports = {
    countFittingSwatches: countFittingSwatches
};
